var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.476868,
    y: 0.577637,
    width: 35.9803,
    height: 36.0048,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_339",
    transform: "matrix(0.0111111 0 0 0.0111036 0 0.000339198)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_339",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACqUlEQVR4nO2cv4sTQRTHt1I5EFGrJPN2nZeEkwhymMu8PRFsr7PwX7D0RyX+CdbWWgniv2CnWOhZqZVob6uIB1q5MnqClU6S2Xlzu98PTJnMm0++vMwG8ooCAAAAAAAAAAAAABSXq+qYEN9yxK+EeF+Im46ufUe8JyXf3J1Mjib96N1oYhzx2wwkNInXG3/2ZEnuqeTmj+wkyfbtIoPDNpqrNuMbrYs+6MlNz9fLBKLt1wwO2mgu76B10dqHlEwWRBNEN9opRKJJXxxaB+lLRY8miFZPnDP8SQw/rI29thhWW7WZjuaDwYa/LVwqy5O1Mae2yykvaHyuNuNdR/YxEk3LCXaGb188vXl8mSuYfw1EU7Do9ztVdXaVOy5EU2CSyX6YM59Y9UECoimkXdjvdTm+sKpkiKbQvmzvrSMZoilI9I/t4ZlNiG77Kmf4+bqSkWgKus7dhegUDyY0vhIiejEc7wjxk18PMhH2LdomhTxZYvknu/9Lrrac4W8x9+2d6NpMRwE1P4q9b+9Ezw9+v/gXzvA7iKb2kyWGP0M0JRCttO9aaLcKgWiIjop2ggWJPoR98C+E+EFWteWW1lg44mdZ1dZZ0YY/ZlVbF0XPB4MN/3NrVrV1UbSM7Pnsauuo6KvZ1dZJ0SXfya62Lop2xPezq62bou3TXouWSAc+lCHQFisQDdFR0U6wINEQHRXtBAsSDdFR0U6wINEQHRXtBAsSDdFR0U6wINEQHRXtBAsSDdFR0U6wINEQHRXtBAsSDdFR0U6wINEQ3elxbEUA0fc19kvvBgwWGqJTDBj0U2f7LtoZe7110X4Aqh+E2mPRr2ez2ZEiBX60by6yiwBiSg75A2n0ZPups75faX5BFgGs8/6/z2Zf+HaRLMkAAAAAAAAAAAAARd78BHzsreLbU0EBAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDark);
export default __webpack_public_path__ + "static/media/facebook-dark.e71932aecbf4245455aeec03cc17ec2d.svg";
export { ForwardRef as ReactComponent };